import * as MockingRestApiPage from "../../../../docs/getting-started/mocks/rest-api.mdx";
import * as MockingGraphQLApiPage from "../../../../docs/getting-started/mocks/graphql-api.mdx";
import * as React from 'react';
export default {
  MockingRestApiPage,
  MockingGraphQLApiPage,
  React
};